<template>
  <span>
    <div v-for="(award, index) in projectAwards" :data-balloon="$t(award.name)" data-balloon-pos="up-right"
          :class="{'award_stemexpo': isStemExpo, 'award': !$isIsef, 'award_ysc': $isYSC }"
          v-bind:style="{'z-index': (projectAwards.length - index + 5),
          'right': spaceBetweenAwards*(projectAwards.length - index) + 'px'}"
          :key="award.id">
      <img v-if="award.showRibbon" :src="award.image" :alt="$t(award.name)"/>
    </div>
  </span>
</template>

<script>
import base from '../mixins/base'

export default {
  mixins: [base],
  props: ['projectAwards', 'isStemExpo', 'isCareerHall', 'isViewAll']
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .award {
    position: absolute;
    width: 13%;
    @include touch {
      width: 15%;
    }
    &_ysc {
      top: 85% !important;
    }
  }
  .award_stemexpo {
    position: absolute;
    height: 45px;
    width: 36px;
    bottom: 40px !important;
    @include tablet-only {
      top: 40px
    }
    @include mobile {
      top: 45px;
    }
  }
  .award_isef {
    position: absolute;
    top: -10px;
    width: 36px;
    height: 45px;
    &_careerHall {
      width: 49px !important;
      height: 55px !important;
    }
    &_viewAll {
      bottom: 22px !important;
      @include tablet {
        top: inherit !important;
      }
      @include mobile {
        top: inherit !important;
      }
    }
  }
</style>
